import React from 'react';
import ReactFileReader from "react-file-reader";
import Select from 'react-select';
import moment from "moment";

const particularList = [
  { label: 'Original', value: 'original' },
  { label: 'Xerox',    value: 'xerox'    },
];

let Ec_dropdown = [
  { name: "SRO Encumbrance Certificate",  key: "SRO Encumbrance Certificate"  },
  { name: "Online Encumbrance Certificate", key: "Online Encumbrance Certificate" },
];

const DashUploadDocument = (props) => {
  const {
    index,
    baseDetails,
    handleDocumentDetailsChange,
    handleDocumentFilesChange,
    deleteFile,
    previewDoc,
    deleteDocumentDetails,
    categoriesList,
    newfile,
    path,
    deedList,
    state,
    isbtnload,
    pendingQueryOptions = [],
  } = props;

  const {
    docNoYear,
    particular,
    type,
    base,
    isValid,
    isSavedFile,
    base_url,
    doc_type,
    query_id,
    query_label,
    query_raised_at,
    isPdfCompress,
    originalSize,
    compressedSize,
  } = baseDetails;

  const validTypes = ['deed', 'mother_doc', 'title_deed'];
  const invalidDocuments = ['26', '27', '36', '35', '38', '103', '78', '5', 'Online Encumbrance Certificate'];

  let pdfCompressDropdown = [
    { value: "on",  label: "On"  },
    { value: "off", label: "Off" },
  ];

  const colStyle = {
    slNo: { minWidth: "60px", flex: "0 0 60px" },
    category: { width: "240px", minWidth: "240px", maxWidth: "240px", flex: "0 0 240px" },
    docType: { width: "310px", minWidth: "310px", maxWidth: "310px", flex: "0 0 310px" },
    pdfCompress: { width: "140px", minWidth: "140px", maxWidth: "140px", flex: "0 0 140px" },
    docNoYear: { width: "170px", minWidth: "170px", maxWidth: "170px", flex: "0 0 170px" },
    particular: { width: "150px", minWidth: "150px", maxWidth: "150px", flex: "0 0 150px" },
    upload: { width: "100px", minWidth: "100px", maxWidth: "100px", flex: "0 0 100px" },
    delete: { width: "44px", minWidth: "44px", maxWidth: "44px", flex: "0 0 44px" },
  };

  const selectMenuPortalTarget = typeof window !== "undefined" ? document.body : null;
  const selectMenuStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };
  const formatQueryDateTime = (value) => {
    if (!value) return "-";
    const parsed = moment(value, ["YYYY-MM-DD HH:mm:ss", "DD-MM-YYYY HH:mm:ss", "DD-MM-YYYY HH:mm:ss.SSS", moment.ISO_8601], true);
    if (parsed.isValid()) return `${parsed.format("DD-MM-YYYY")} ${parsed.format("hh:mm A")}`;
    const fallback = moment(value);
    return fallback.isValid() ? `${fallback.format("DD-MM-YYYY")} ${fallback.format("hh:mm A")}` : "-";
  };

  const actionIconBtnStyle = {
    border: "1px solid #dbe3ef",
    background: "#ffffff",
    color: "#334155",
    borderRadius: "8px",
    width: "28px",
    height: "28px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    transition: "all 0.2s ease",
    padding: 0,
  };

  return (
    <div className="upload-document-wrapper" style={{ border: "1px solid #e6ecf5", borderRadius: "10px", padding: "8px 10px", marginBottom: "8px", background: "#ffffff", boxShadow: "0 1px 3px rgba(15, 23, 42, 0.05)" }}>
      <div className="upload-document-folder align-items-start" style={{ display: "flex", flexWrap: "nowrap", gap: "10px", overflowX: "auto", overflowY: "hidden", paddingBottom: "2px" }}>
        {/* ── Serial number ────────────────────────────────────────────────── */}
        <div style={colStyle.slNo}>
          <div className="form-group" style={{ marginBottom: "6px" }}>
            <div className="row">
              <div className="col-md-6">
                <label>{index === 0 && 'Sl.No'}</label>
              </div>
            </div>
            <p style={{ paddingTop: "8px", marginBottom: 0, fontWeight: 500 }}>{index + 1}</p>
          </div>
        </div>

        {/* ── Category ─────────────────────────────────────────────────────── */}
        <div style={colStyle.category}>
          <div className="form-group" style={{ marginBottom: "6px" }}>
            <label>Category</label>
            {categoriesList && categoriesList.length > 0 &&
              categoriesList.map((opt) => { opt.label = opt.name; opt.value = opt.id; }) &&
              <Select
                options={categoriesList}
                name="category"
                value={categoriesList.find((o) => o.value === type)}
                onChange={e => handleDocumentDetailsChange(e.value, index, 'type')}
                placeholder="example: Title Deed"
                menuPortalTarget={selectMenuPortalTarget}
                menuPosition="fixed"
                styles={selectMenuStyles}
              />
            }
            {!type && <p style={{ color: 'red', fontSize: '14px' }}>Please fill the field.</p>}
          </div>
        </div>

        {/* ── Document Type ─────────────────────────────────────────────────── */}
        {(type === 'rev_rec_doc' || type === 'deed' || type === 'mother_doc' ||
          type === 'title_deed' || type === 'ec_doc' || type === 'sale_agreement') && (
          <div style={colStyle.docType}>
            <div className="form-group" style={{ marginBottom: "6px" }}>
              <label>
                Document Type<span style={{ color: '#FF0000' }}>*</span>
              </label>
              {type !== 'ec_doc' ? (
                deedList && deedList.length > 0 &&
                deedList.map((opt) => { opt.label = opt.name; opt.value = opt.id; }) &&
                <Select
                  options={deedList}
                  name="doc_type"
                  value={deedList.find((o) => o.value === doc_type)}
                  onChange={e => handleDocumentDetailsChange(e.value, index, 'doc_type')}
                  menuPortalTarget={selectMenuPortalTarget}
                  menuPosition="fixed"
                  styles={selectMenuStyles}
                />
              ) : (
                Ec_dropdown && Ec_dropdown.length > 0 &&
                Ec_dropdown.map((opt) => { opt.label = opt.name; opt.value = opt.name; }) &&
                <Select
                  options={Ec_dropdown}
                  name="doc_type"
                  value={Ec_dropdown.find((o) => o.value === doc_type)}
                  onChange={e => handleDocumentDetailsChange(e.value, index, 'doc_type')}
                  menuPortalTarget={selectMenuPortalTarget}
                  menuPosition="fixed"
                  styles={selectMenuStyles}
                />
              )}
              {!doc_type && <p style={{ color: 'red', fontSize: '14px' }}>Please fill the field.</p>}
            </div>
          </div>
        )}

        {/* ── PDF Compress toggle ───────────────────────────────────────────── */}
        {(state.isGlobalPdfCompress && state.isFrontOfficePdfCompressShow) && (
          <div style={colStyle.pdfCompress}>
            <div className="form-group" style={{ marginBottom: "6px" }}>
              <label>PDF Compress</label>
              <Select
                options={pdfCompressDropdown}
                name="isPdfCompress"
                value={pdfCompressDropdown.find(o => o.value === isPdfCompress)}
                onChange={e => handleDocumentDetailsChange(e.value, index, 'isPdfCompress')}
                placeholder="example: Select Option"
                menuPortalTarget={selectMenuPortalTarget}
                menuPosition="fixed"
                styles={selectMenuStyles}
              />
            </div>
          </div>
        )}

        {/* ── Doc No / Year ─────────────────────────────────────────────────── */}
        {(type === 'ec_doc' || validTypes.includes(type)) &&
          (doc_type === 'SRO Encumbrance Certificate' || !invalidDocuments.includes(doc_type)) && (
          <div style={colStyle.docNoYear}>
            <div className="form-group" style={{ marginBottom: "6px" }}>
              <div className="row">
                <div className="col-md-6">
                  <label>Doc.No/Year</label>
                </div>
              </div>
              <input
                className="form-control"
                name="docNoYear"
                placeholder="example: 1501/1996"
                type="text"
                value={docNoYear}
                onChange={e => handleDocumentDetailsChange(e.target.value, index, 'docNoYear')}
              />
              {!docNoYear && <p style={{ color: 'red', fontSize: '14px' }}>Please fill the field.</p>}
            </div>
          </div>
        )}

        {/* ── Particular ────────────────────────────────────────────────────── */}
        <div style={colStyle.particular}>
          <div className="form-group" style={{ marginBottom: "6px" }}>
            <label>Particular</label>
            <Select
              options={particularList}
              name="particular"
              value={particularList.find((o) => o.value === particular)}
              onChange={(e) => handleDocumentDetailsChange(e.value, index, 'particular')}
              placeholder="example: Xerox"
              menuPortalTarget={selectMenuPortalTarget}
              menuPosition="fixed"
              styles={selectMenuStyles}
            />
            {!particular && <p style={{ color: 'red', fontSize: '14px' }}>Please fill the field.</p>}
          </div>
        </div>

        {/* ── Pending Query Mapping (Received Query Mail modal only) ───────── */}
        {path === "querymaildetails" && (
          <div style={{ width: "230px", minWidth: "230px", maxWidth: "230px", flex: "0 0 230px" }}>
            <div className="form-group" style={{ marginBottom: "6px" }}>
              <label>Map Pending Query</label>
              <Select
                options={pendingQueryOptions}
                name="query_id"
                value={pendingQueryOptions.find((o) => String(o.value) === String(query_id))}
                onChange={(selected) => {
                  handleDocumentDetailsChange(selected ? selected.value : "", index, "query_id");
                  handleDocumentDetailsChange(selected ? selected.label : "", index, "query_label");
                }}
                placeholder="Select pending query"
                isClearable={true}
                menuPortalTarget={selectMenuPortalTarget}
                menuPosition="fixed"
                styles={selectMenuStyles}
              />
            </div>
          </div>
        )}

        {/* ── File upload button  ───────────────────────────────────────────── */}
        {!newfile && !base && (
          <div className="upload-document-filereader" style={colStyle.upload}>
            <div className="form-group" style={{ marginBottom: "6px" }}>
              <label style={{ marginBottom: "8px", height: "21px", lineHeight: "21px", visibility: "hidden", display: "block" }}>Upload</label>
              <ReactFileReader
                fileTypes={['.pdf']}
                base64={true}
                multipleFiles={false}
                handleFiles={e => handleDocumentFilesChange(e, index, baseDetails)}
              >
                {!newfile && (
                  <button className="ml2 btn btn-primary btnupload float-right" style={{ marginTop: 0, padding: "6px 10px", borderRadius: "8px", minWidth: "86px", height: "34px", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                    {isbtnload && <i className="fa fa-spinner fa-spin"></i>}
                    Upload +
                  </button>
                )}
              </ReactFileReader>
              {!base && (
                <p style={{ color: 'red', fontSize: '12px', marginBottom: 0, marginTop: "6px" }}>
                  Please upload.
                </p>
              )}
            </div>
          </div>
        )}

        {/* ── Delete row ────────────────────────────────────────────────────── */}
        {!isSavedFile && (
          <div style={{ ...colStyle.delete, paddingTop: "22px" }}>
            <div style={{ padding: "6px 8px" }} className="form-group">
              <button
                type="button"
                title="Delete Row"
                onClick={() => deleteDocumentDetails(index)}
                style={{ ...actionIconBtnStyle, color: "#b91c1c", borderColor: "#fecaca", background: "#fff1f2" }}
              >
                <i style={{ fontSize: "14px" }} className="fa fa-trash-o" />
              </button>
            </div>
          </div>
        )}
      </div>

      {query_id && query_label && (
        <div style={{ marginTop: "2px", paddingLeft: "4px", overflow: "hidden" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              gap: "6px 10px",
              fontSize: "12px",
              lineHeight: "16px",
              justifyContent: "flex-start",
            }}
          >
            <span style={{ color: "#334155", fontWeight: 600, flexShrink: 0 }}>Mapped Query:</span>
            <span
              style={{
                color: "#64748b",
                minWidth: 0,
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {query_label}
            </span>
            {query_raised_at && (
              <>
                <span style={{ fontWeight: 700, color: "#50617c", flexShrink: 0 }}>Raised Date &amp; Time</span>
                <span style={{ color: "#42536d", whiteSpace: "nowrap", flexShrink: 0 }}>
                  {formatQueryDateTime(query_raised_at)}
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── Attached file card ────────────────────────────────────────────── */}
      {base && (
        <div
          key={index}
          style={{
            marginTop: "6px",
            border: "1px solid #e2e8f0",
            borderRadius: "10px",
            background: "#f8fafc",
            padding: "8px 10px",
            width: "50%",
            minWidth: "320px",
            maxWidth: "680px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: "8px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px", minWidth: 0 }}>
              <i className="feather icon-file-text" style={{ color: "#16a34a", fontSize: "16px" }} />
              <span style={{ fontSize: "14px", color: "#0f172a", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{base}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px", flexShrink: 0 }}>
              <button
                type="button"
                className="icon-btn"
                title="View"
                data-toggle="modal"
                data-target="#preview-document"
                onClick={() => previewDoc(base_url || "")}
                style={actionIconBtnStyle}
              >
                <i className="fa fa-eye" style={{ fontSize: "14px" }} />
              </button>
              <button
                type="button"
                className="icon-btn"
                title="Close"
                onClick={() => deleteFile(index)}
                style={{ ...actionIconBtnStyle, color: "#b91c1c", borderColor: "#fecaca", background: "#fff1f2" }}
              >
                <i className="fa fa-times" style={{ fontSize: "14px" }} />
              </button>
            </div>
          </div>
          {originalSize != null && originalSize !== '' && (
            <p style={{ margin: "6px 0 0", fontSize: "12px", color: "#64748b" }}>
              {(isPdfCompress === 'on' && state.isGlobalPdfCompress)
                ? `Original Size: ${originalSize}, Compressed Size: ${compressedSize}`
                : `File Size: ${originalSize}`
              }
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default DashUploadDocument;